// extracted by mini-css-extract-plugin
export default {"container":"InteractionLottie_container__rPDDO","scaleUp":"InteractionLottie_scaleUp__DKbzS"};